var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 4.875C20.9062 7.88876 25.3522 9.45791 29.8956 9.25C30.5571 11.5002 30.7595 13.8605 30.4908 16.1905C30.2221 18.5205 29.4878 20.7727 28.3314 22.8133C27.1751 24.8539 25.6204 26.6412 23.7596 28.069C21.8989 29.4969 19.7701 30.5361 17.4998 31.125M17.4998 4.875C14.0934 7.88876 9.64744 9.45791 5.10397 9.25C4.44248 11.5002 4.24007 13.8605 4.50878 16.1905C4.77749 18.5205 5.51183 20.7727 6.66817 22.8133C7.8245 24.8539 9.37923 26.6412 11.24 28.069C13.1007 29.4969 15.2295 30.5361 17.4998 31.125M17.4998 4.875V31.125M17.5 16.5417H30.4792M17.5 12.1667H30.4792M17.5 7.79167H22.0209M17.5 25.2917H26.5417M17.5 20.9167H29.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaySafe);
export default __webpack_public_path__ + "static/media/stay_safe.0925ec7020fbe8dd3f67ee9088d26d34.svg";
export { ForwardRef as ReactComponent };